var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAzureSftpIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#0F6CBD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.2 9.6h6.1l-1.5-1.5 1-1 3.2 3.2-3.2 3.2-1-1 1.5-1.5H6.2v-1.4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8 14.4h-6.1l1.5 1.5-1 1-3.2-3.2 3.2-3.2 1 1-1.5 1.5h6.1v1.4Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureSftpIcon);
export default __webpack_public_path__ + "static/media/azure-sftp-icon.9dfa24f20a1c13395c2faad9ba31a775.svg";
export { ForwardRef as ReactComponent };